<template>
  <dropdown-notification v-cloak>
    <div slot="fa-icon">
      <i class="fa fa-exclamation" aria-hidden="true"></i>
      <span id="alertas" class="badge-warning">{{ notificaciones.length }}</span>
    </div>
    <div slot="content">
      <div class="notification__name bg-primary">Notificaciones</div>
      <ul>
        <li v-for="(notificacion, index) in notificaciones" :key="index">
          <a
            :target="notificacion.url != null?'_blank':null"
            :href="notificacion.url != null?notificacion.url:'#'"
          >
            <span>{{ notificacion.descripcion }}</span>
          </a>
        </li>
        <li v-show="notificaciones.length === 0">
          <a href="#">No hay notificaciones disponibles.</a>
        </li>
      </ul>
    </div>
  </dropdown-notification>
</template>

<script>
export default {
  data: function() {
    return {
      notificaciones: []
    };
  },
  methods: {
    cargarNotificaciones: function() {
      let that = this;
      let xmlhttp = new XMLHttpRequest();
      xmlhttp.onreadystatechange = function() {
        if (
          (this.readyState == 4 && this.status == 200) ||
          this.status == 201
        ) {
         
          let json = '';
          that.notificaciones = JSON.parse(this.responseText);
           that.notificaciones = that.notificaciones.notificaciones;
        }
      };
      xmlhttp.open("GET", url + "/anotificaciones", true);
      xmlhttp.send();
    }
  },
  mounted: function() {
    this.cargarNotificaciones();
    let that = this;
    setInterval(function() {
      that.cargarNotificaciones();
    }, 1000 * 60 * 5);
  }
};
</script>



// WEBPACK FOOTER //
// resources/assets/js/components/element/Notificaciones.vue